export enum StorageKey {
	USER_INFO = 'user-info',
	TOKEN = 'token',
	REFRESH_TOKEN = 'refresh-token'
  }
